import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/leadFunctions/leadProposalActions'
import * as api from '../../api/lead/proposals'
import { fetchLeadDetails } from '../leadDetails'

export function* leadProposalsRefresh(action) {
  try {
    const payload = yield call(api.getLeadProposals, action.leadId)
    yield put({ type: constants.LEAD_PROPOSALS_REFRESH.SUCCESS, payload })

    action.next && action.next(null, payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_PROPOSALS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchLeadProposals() {
  yield takeLatest(constants.LEAD_PROPOSALS_REFRESH.ACTION, leadProposalsRefresh)
}

export function* temporarilySavedLeadProposalsRefresh(action) {
  try {
    const payload = yield call(api.getTemporarilySavedLeadProposals, action.leadId)
    yield put({ type: constants.TEMPORARILY_SAVED_LEAD_PROPOSALS_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.TEMPORARILY_SAVED_LEAD_PROPOSALS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchTemporailySavedLeadProposalsRefresh() {
  yield takeLatest(
    constants.TEMPORARILY_SAVED_LEAD_PROPOSALS_REFRESH.ACTION,
    temporarilySavedLeadProposalsRefresh
  )
}

function* sagaCreateLeadProposal(action) {
  try {
    const payload = {
      proposal_data: {
        ...action.content,
        created_by_id: action.userId,
        updated_by_id: action.userId
      },
      lead_id: action.leadId,
      proposalSections: action.proposalSections,
      proposalMilestones: action.proposalMilestones
    }

    yield call(api.createLeadProposal, payload)
    yield put({ type: constants.LEAD_PROPOSAL_CREATE.SUCCESS, payload })
    yield call(leadProposalsRefresh, { leadId: action.leadId })
    yield call(temporarilySavedLeadProposalsRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_PROPOSAL_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateLeadProposal() {
  yield takeLatest(constants.LEAD_PROPOSAL_CREATE.ACTION, sagaCreateLeadProposal)
}

function* sagaUpdateLeadProposal(action) {
  try {
    const payload = {
      lead_id: action.leadId,
      proposal_id: action.proposalId,
      proposal_data: {
        ...action.content,
        created_by_id: action.userId,
        updated_by_id: action.userId
      },
      proposalSections: action.proposalSections,
      proposalMilestones: action.proposalMilestones
    }
    yield call(api.updateLeadProposal, payload)
    yield put({ type: constants.LEAD_PROPOSAL_UPDATE.SUCCESS, payload })
    yield call(leadProposalsRefresh, { leadId: action.leadId })
    yield call(temporarilySavedLeadProposalsRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_PROPOSAL_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateLeadProposal() {
  yield takeLatest(constants.LEAD_PROPOSAL_UPDATE.ACTION, sagaUpdateLeadProposal)
}

function* sagaDeleteLeadProposal(action) {
  try {
    const payload = {
      leadId: action.leadId,
      proposal_id: action.proposalId
    }
    yield call(api.deleteLeadProposal, payload)
    yield put({ type: constants.LEAD_PROPOSAL_DELETE.SUCCESS, payload })
    yield call(leadProposalsRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
    yield call(temporarilySavedLeadProposalsRefresh, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_PROPOSAL_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteLeadProposal() {
  yield takeLatest(constants.LEAD_PROPOSAL_DELETE.ACTION, sagaDeleteLeadProposal)
}

function* getProposalSections(action) {
  try {
    const payload = yield call(api.getProposalSections, action.proposalId)
    yield put({ type: constants.GET_LEAD_PROPOSAL_SECTIONS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_LEAD_PROPOSAL_SECTIONS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetProposalSections() {
  yield takeLatest(constants.GET_LEAD_PROPOSAL_SECTIONS.ACTION, getProposalSections)
}

function* getProposalItems(action) {
  try {
    const payload = yield call(api.getProposalItems, action.proposalId)
    yield put({ type: constants.GET_LEAD_PROPOSAL_ITEMS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_LEAD_PROPOSAL_ITEMS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetProposalItems() {
  yield takeLatest(constants.GET_LEAD_PROPOSAL_ITEMS.ACTION, getProposalItems)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchLeadProposals),
    fork(watchTemporailySavedLeadProposalsRefresh),

    fork(watchCreateLeadProposal),
    fork(watchUpdateLeadProposal),
    fork(watchDeleteLeadProposal),

    fork(watchGetProposalSections),
    fork(watchGetProposalItems)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/leadFunctions/leadProposalSaga.js